import { useEffect } from "react";
import { useSessionConfigStore } from "../Store/sessionConfigStore";

const getConfigKey = (item) => {
  if (!item) return "";
  if (item.fixCustomerMappingId != null) {
    return `id-${item.fixCustomerMappingId}`;
  }
  return `${item.custId ?? ""}-${item.venueId ?? ""}-${item.senderCompId ?? ""}-${item.targetCompId ?? ""}-${item.connectionType ?? ""}`;
};

export const useSessionConfigWebSocketUpdate = () => {
  const setSessionData = useSessionConfigStore((state) => state.setSessionData);
  const setTotalElements = useSessionConfigStore((state) => state.setTotalElements);

  useEffect(() => {
    const handleUpdate = (event) => {
      const payload = event?.detail;
      if (!payload) return;

      const updatedKey = getConfigKey(payload);
      if (!updatedKey) return;

      const { sessionData = [], totalElements = 0 } = useSessionConfigStore.getState();

      const existingIndex = sessionData.findIndex((item) => getConfigKey(item) === updatedKey);
      const isDelete = payload.isActive === 0 || payload.isActive === "0";

      if (isDelete) {
        if (existingIndex !== -1) {
          const nextData = sessionData.filter((item) => getConfigKey(item) !== updatedKey);
          setSessionData(nextData);
          setTotalElements(Math.max((totalElements || 0) - 1, 0));
        }
        return;
      }

      if (existingIndex !== -1) {
        const nextData = [...sessionData];
        nextData[existingIndex] = { ...nextData[existingIndex], ...payload };
        setSessionData(nextData);
      } else {
        setSessionData([payload, ...sessionData]);
        setTotalElements((totalElements || 0) + 1);
      }
    };

    window.addEventListener("fixSessionConfigUpdate", handleUpdate);
    return () => {
      window.removeEventListener("fixSessionConfigUpdate", handleUpdate);
    };
  }, [setSessionData, setTotalElements]);
};

export default useSessionConfigWebSocketUpdate;
